<template>
  <div class="material-card-list mr-6 mb-6">
    <div class="image relative mb-2">
      <button
        class="rounded flex justify-center bg-white items-center focus:outline-none absolute top-2 left-2 w-6 h-6"
        @click="toggleCheck"
      >
        <span class="check"><i
            v-if="check"
            class="fas fa-check text-red-500"
          ></i></span>
      </button>
      <div class="absolute top-2 right-2 bg-white rounded w-6 h-6 flex justify-center items-center">
        <i
          v-if="!material.data.attributes.status"
          class="fa fa-lock text-red-500"
          :title="$t('main.blocked')"
        ></i>
        <i
          v-else
          class="fa fa-check text-green-500"
          :title="$t('main.published')"
        ></i>
      </div>

      <div
        class="thumb block rounded border-2 border-white"
        :style="{ backgroundImage: `url(${material.data.attributes.image})` }"
      ></div>
    </div>
    <div class="article font-bold text-sm">
      {{ material.data.attributes.article }}
    </div>
    <div class="name text-xs">
      {{ material.data.attributes.name.substr(0, 15) }}...
    </div>
    <div class="coefficient text-sm">
      {{ $t('admin.materials.list_card_in_element.coef') }}:
      <span class="font-bold underline">{{
        material.data.attributes.cost_coefficient
      }}</span>
    </div>
    <div class="price-cub text-xs">
      <div v-html="$t('admin.materials.list_card_in_element.price_cub')"></div>
        <div>{{ $toCurrency(material.data.attributes.price) }}</div>
    </div>
    <div class="cost-value text-xs">
      <div v-html="$t('admin.materials.list_card_in_element.cost_cub')"></div>
        <div>{{ $toCurrency(material.data.attributes.cost) }}</div>
    </div>
    <div
      class="type text-xs"
      v-if="material.data.attributes.type"
    >
      {{ $knifeString(material.data.attributes.type.name, 15) }}
    </div>
  </div>
</template>

<script>
export default {
  name: "MaterialListCardToCheck",
  props: {
    material: {
      type: Object,
      required: true,
    },
  },
  methods: {
    toggleCheck() {
      if (this.check) {
        this.$store.dispatch(
          "elements/removeElementMaterial",
          this.material.data.material_id
        );
      } else {
        this.$store.dispatch("elements/addElementMaterial", this.material);
      }
    },
  },
  computed: {
    element_materials() {
      return this.$store.state.elements.element_materials;
    },
    check() {
      const element_material = this.element_materials.find(
        (el_material) =>
          el_material.data.material_id == this.material.data.material_id
      );
      return element_material;
    },
  },
};
</script>

<style scoped>
.material-card-list {
  display: flex;
  flex-direction: column;
  row-gap: 3px;
}
</style>
